/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Location_Opted_Out_TitleInputs */

const en_ticket_location_opted_out_title = /** @type {(inputs: Ticket_Location_Opted_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location sharing is off`)
};

const ja_ticket_location_opted_out_title = /** @type {(inputs: Ticket_Location_Opted_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置情報の共有はオフです`)
};

const fr_ticket_location_opted_out_title = /** @type {(inputs: Ticket_Location_Opted_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partage de position désactivé`)
};

const de_ticket_location_opted_out_title = /** @type {(inputs: Ticket_Location_Opted_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standortfreigabe ist aus`)
};

/**
* | output |
* | --- |
* | "Location sharing is off" |
*
* @param {Ticket_Location_Opted_Out_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_location_opted_out_title = /** @type {((inputs?: Ticket_Location_Opted_Out_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Location_Opted_Out_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_location_opted_out_title(inputs)
	if (locale === "ja") return ja_ticket_location_opted_out_title(inputs)
	if (locale === "fr") return fr_ticket_location_opted_out_title(inputs)
	return de_ticket_location_opted_out_title(inputs)
});